<template>
  <v-card>
    <alert-error :error="error"></alert-error>

    <v-card-title>
      {{ $t('REPORTS.ALL_INHABITANTS_OF_B_CUSTOMER') }}
    </v-card-title>

    <v-card-text>
      <v-select
        v-if="businessCustomers"
        v-model="businessCustomerId"
        :items="businessCustomers"
        item-value="id"
        item-text="name"
        :label="$t('BUILDING_COMPLEXES.BUSINESS_CUSTOMER')"
        @change="getDataExport"
      ></v-select>
    </v-card-text>

    <v-container grid-list-md text-md-right fluid fill-height>
      <v-spacer></v-spacer>

      <v-btn :disabled="!businessCustomerId">
        <JsonExcel
          :data="dataExport"
          :fields="exportFields"
          :name="
            `${$t('REPORTS.ALL_INHABITANTS_OF_B_CUSTOMER') + datetime}.xls`
          "
        >
          {{ $t('BUTTON.EXPORT') }}
        </JsonExcel>
      </v-btn>
    </v-container>
  </v-card>
</template>

<script>
import JsonExcel from 'vue-json-excel';

export default {
  name: 'BusinessCustomerHabitation',

  components: {
    JsonExcel,
    AlertError: () => import('@/modules/_global/_components/AlertError')
  },

  data: () => ({
    businessCustomers: null,
    businessCustomerId: null,
    dataExport: null,
    datetime: '',
    error: null
  }),

  computed: {
    exportFields() {
      return {
        [this.$t('ITEM.ID')]: 'person_id',
        [this.$t('PROFILE.FIRST_NAME')]: 'first_name',
        [this.$t('PROFILE.LAST_NAME')]: 'last_name',
        [this.$t('PROFILE.EMAIL')]: 'email',
        [this.$t('PROFILE.PHONE')]: 'phone',
        [this.$t('BUILDING_COMPLEXES.ITEM')]: 'building_complex',
        [this.$t('PROFILE.STREET')]: 'building',
        [this.$t('PROFILE.ZIP')]: 'zip',
        [this.$t('PROFILE.CITY')]: 'city',
        [this.$t('APARTMENTS.ITEM')]: 'apartment',
        [this.$t('PROFILE.STATUS')]: 'person_status',
        [this.$t('INHABITANTS.DATE_FROM')]: 'date_from'
      };
    }
  },

  created() {
    this.datetime = new Date().toISOString().slice(0, 10);

    // get all business customers
    this.$store
      .dispatch('company/retrieveCompaniesByType', 1)
      .then(response => {
        this.businessCustomers = response.data;
      })
      .catch(error => {
        this.error = error.response;
      });
  },

  methods: {
    getDataExport() {
      this.$store
        .dispatch(
          'report/retrieveBusinessCustomerHabitation',
          this.businessCustomerId
        )
        .then(response => {
          this.dataExport = response.data;
        })
        .catch(error => {
          this.error = error.response;
        });
    }
  }
};
</script>
